const R = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, V = (n, e, t) => {
  let r;
  const a = R[n];
  return typeof a == "string" ? r = a : e === 1 ? r = a.one : r = a.other.replace("{{count}}", e.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + r : r + " ago" : r;
};
function Y(n) {
  return (e = {}) => {
    const t = e.width ? String(e.width) : n.defaultWidth;
    return n.formats[t] || n.formats[n.defaultWidth];
  };
}
const I = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, J = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, $ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, z = {
  date: Y({
    formats: I,
    defaultWidth: "full"
  }),
  time: Y({
    formats: J,
    defaultWidth: "full"
  }),
  dateTime: Y({
    formats: $,
    defaultWidth: "full"
  })
}, U = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, K = (n, e, t, r) => U[n];
function k(n) {
  return (e, t) => {
    const r = t != null && t.context ? String(t.context) : "standalone";
    let a;
    if (r === "formatting" && n.formattingValues) {
      const u = n.defaultFormattingWidth || n.defaultWidth, c = t != null && t.width ? String(t.width) : u;
      a = n.formattingValues[c] || n.formattingValues[u];
    } else {
      const u = n.defaultWidth, c = t != null && t.width ? String(t.width) : n.defaultWidth;
      a = n.values[c] || n.values[u];
    }
    const i = n.argumentCallback ? n.argumentCallback(e) : e;
    return a[i];
  };
}
const Z = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, p = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, ee = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, te = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, ne = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, re = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, ae = (n, e) => {
  const t = Number(n), r = t % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, ie = {
  ordinalNumber: ae,
  era: k({
    values: Z,
    defaultWidth: "wide"
  }),
  quarter: k({
    values: p,
    defaultWidth: "wide",
    argumentCallback: (n) => n - 1
  }),
  month: k({
    values: ee,
    defaultWidth: "wide"
  }),
  day: k({
    values: te,
    defaultWidth: "wide"
  }),
  dayPeriod: k({
    values: ne,
    defaultWidth: "wide",
    formattingValues: re,
    defaultFormattingWidth: "wide"
  })
};
function x(n) {
  return (e, t = {}) => {
    const r = t.width, a = r && n.matchPatterns[r] || n.matchPatterns[n.defaultMatchWidth], i = e.match(a);
    if (!i)
      return null;
    const u = i[0], c = r && n.parsePatterns[r] || n.parsePatterns[n.defaultParseWidth], o = Array.isArray(c) ? se(c, (g) => g.test(u)) : (
      // [TODO] -- I challenge you to fix the type
      ue(c, (g) => g.test(u))
    );
    let d;
    d = n.valueCallback ? n.valueCallback(o) : o, d = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(d)
    ) : d;
    const h = e.slice(u.length);
    return { value: d, rest: h };
  };
}
function ue(n, e) {
  for (const t in n)
    if (Object.prototype.hasOwnProperty.call(n, t) && e(n[t]))
      return t;
}
function se(n, e) {
  for (let t = 0; t < n.length; t++)
    if (e(n[t]))
      return t;
}
function ce(n) {
  return (e, t = {}) => {
    const r = e.match(n.matchPattern);
    if (!r) return null;
    const a = r[0], i = e.match(n.parsePattern);
    if (!i) return null;
    let u = n.valueCallback ? n.valueCallback(i[0]) : i[0];
    u = t.valueCallback ? t.valueCallback(u) : u;
    const c = e.slice(a.length);
    return { value: u, rest: c };
  };
}
const oe = /^(\d+)(th|st|nd|rd)?/i, de = /\d+/i, fe = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, he = {
  any: [/^b/i, /^(a|c)/i]
}, me = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, le = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ge = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, we = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, ye = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, be = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Pe = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Me = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Oe = {
  ordinalNumber: ce({
    matchPattern: oe,
    parsePattern: de,
    valueCallback: (n) => parseInt(n, 10)
  }),
  era: x({
    matchPatterns: fe,
    defaultMatchWidth: "wide",
    parsePatterns: he,
    defaultParseWidth: "any"
  }),
  quarter: x({
    matchPatterns: me,
    defaultMatchWidth: "wide",
    parsePatterns: le,
    defaultParseWidth: "any",
    valueCallback: (n) => n + 1
  }),
  month: x({
    matchPatterns: ge,
    defaultMatchWidth: "wide",
    parsePatterns: we,
    defaultParseWidth: "any"
  }),
  day: x({
    matchPatterns: ye,
    defaultMatchWidth: "wide",
    parsePatterns: be,
    defaultParseWidth: "any"
  }),
  dayPeriod: x({
    matchPatterns: Pe,
    defaultMatchWidth: "any",
    parsePatterns: Me,
    defaultParseWidth: "any"
  })
}, ke = {
  code: "en-US",
  formatDistance: V,
  formatLong: z,
  formatRelative: K,
  localize: ie,
  match: Oe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let xe = {};
function v() {
  return xe;
}
const j = 6048e5, We = 864e5, q = Symbol.for("constructDateFrom");
function y(n, e) {
  return typeof n == "function" ? n(e) : n && typeof n == "object" && q in n ? n[q](e) : n instanceof Date ? new n.constructor(e) : new Date(e);
}
function l(n, e) {
  return y(e || n, n);
}
function N(n) {
  const e = l(n), t = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return t.setUTCFullYear(e.getFullYear()), +n - +t;
}
function De(n, ...e) {
  const t = y.bind(
    null,
    e.find((r) => typeof r == "object")
  );
  return e.map(t);
}
function H(n, e) {
  const t = l(n, e == null ? void 0 : e.in);
  return t.setHours(0, 0, 0, 0), t;
}
function ve(n, e, t) {
  const [r, a] = De(
    t == null ? void 0 : t.in,
    n,
    e
  ), i = H(r), u = H(a), c = +i - N(i), o = +u - N(u);
  return Math.round((c - o) / We);
}
function Se(n, e) {
  const t = l(n, e == null ? void 0 : e.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function Ye(n, e) {
  const t = l(n, e == null ? void 0 : e.in);
  return ve(t, Se(t)) + 1;
}
function W(n, e) {
  var c, o, d, h;
  const t = v(), r = (e == null ? void 0 : e.weekStartsOn) ?? ((o = (c = e == null ? void 0 : e.locale) == null ? void 0 : c.options) == null ? void 0 : o.weekStartsOn) ?? t.weekStartsOn ?? ((h = (d = t.locale) == null ? void 0 : d.options) == null ? void 0 : h.weekStartsOn) ?? 0, a = l(n, e == null ? void 0 : e.in), i = a.getDay(), u = (i < r ? 7 : 0) + i - r;
  return a.setDate(a.getDate() - u), a.setHours(0, 0, 0, 0), a;
}
function D(n, e) {
  return W(n, { ...e, weekStartsOn: 1 });
}
function G(n, e) {
  const t = l(n, e == null ? void 0 : e.in), r = t.getFullYear(), a = y(t, 0);
  a.setFullYear(r + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const i = D(a), u = y(t, 0);
  u.setFullYear(r, 0, 4), u.setHours(0, 0, 0, 0);
  const c = D(u);
  return t.getTime() >= i.getTime() ? r + 1 : t.getTime() >= c.getTime() ? r : r - 1;
}
function Te(n, e) {
  const t = G(n, e), r = y(n, 0);
  return r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0), D(r);
}
function Fe(n, e) {
  const t = l(n, e == null ? void 0 : e.in), r = +D(t) - +Te(t);
  return Math.round(r / j) + 1;
}
function B(n, e) {
  var h, g, M, O;
  const t = l(n, e == null ? void 0 : e.in), r = t.getFullYear(), a = v(), i = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((g = (h = e == null ? void 0 : e.locale) == null ? void 0 : h.options) == null ? void 0 : g.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((O = (M = a.locale) == null ? void 0 : M.options) == null ? void 0 : O.firstWeekContainsDate) ?? 1, u = y((e == null ? void 0 : e.in) || n, 0);
  u.setFullYear(r + 1, 0, i), u.setHours(0, 0, 0, 0);
  const c = W(u, e), o = y((e == null ? void 0 : e.in) || n, 0);
  o.setFullYear(r, 0, i), o.setHours(0, 0, 0, 0);
  const d = W(o, e);
  return +t >= +c ? r + 1 : +t >= +d ? r : r - 1;
}
function Ee(n, e) {
  var c, o, d, h;
  const t = v(), r = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((o = (c = e == null ? void 0 : e.locale) == null ? void 0 : c.options) == null ? void 0 : o.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((h = (d = t.locale) == null ? void 0 : d.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, a = B(n, e), i = y((e == null ? void 0 : e.in) || n, 0);
  return i.setFullYear(a, 0, r), i.setHours(0, 0, 0, 0), W(i, e);
}
function Ce(n, e) {
  const t = l(n, e == null ? void 0 : e.in), r = +W(t, e) - +Ee(t, e);
  return Math.round(r / j) + 1;
}
function s(n, e) {
  const t = n < 0 ? "-" : "", r = Math.abs(n).toString().padStart(e, "0");
  return t + r;
}
const w = {
  // Year
  y(n, e) {
    const t = n.getFullYear(), r = t > 0 ? t : 1 - t;
    return s(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M(n, e) {
    const t = n.getMonth();
    return e === "M" ? String(t + 1) : s(t + 1, 2);
  },
  // Day of the month
  d(n, e) {
    return s(n.getDate(), e.length);
  },
  // AM or PM
  a(n, e) {
    const t = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(n, e) {
    return s(n.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(n, e) {
    return s(n.getHours(), e.length);
  },
  // Minute
  m(n, e) {
    return s(n.getMinutes(), e.length);
  },
  // Second
  s(n, e) {
    return s(n.getSeconds(), e.length);
  },
  // Fraction of second
  S(n, e) {
    const t = e.length, r = n.getMilliseconds(), a = Math.trunc(
      r * Math.pow(10, t - 3)
    );
    return s(a, e.length);
  }
}, P = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Q = {
  // Era
  G: function(n, e, t) {
    const r = n.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return t.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return t.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(n, e, t) {
    if (e === "yo") {
      const r = n.getFullYear(), a = r > 0 ? r : 1 - r;
      return t.ordinalNumber(a, { unit: "year" });
    }
    return w.y(n, e);
  },
  // Local week-numbering year
  Y: function(n, e, t, r) {
    const a = B(n, r), i = a > 0 ? a : 1 - a;
    if (e === "YY") {
      const u = i % 100;
      return s(u, 2);
    }
    return e === "Yo" ? t.ordinalNumber(i, { unit: "year" }) : s(i, e.length);
  },
  // ISO week-numbering year
  R: function(n, e) {
    const t = G(n);
    return s(t, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(n, e) {
    const t = n.getFullYear();
    return s(t, e.length);
  },
  // Quarter
  Q: function(n, e, t) {
    const r = Math.ceil((n.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return s(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(n, e, t) {
    const r = Math.ceil((n.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return s(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(n, e, t) {
    const r = n.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return w.M(n, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return t.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return t.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(n, e, t) {
    const r = n.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return s(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return t.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return t.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(n, e, t, r) {
    const a = Ce(n, r);
    return e === "wo" ? t.ordinalNumber(a, { unit: "week" }) : s(a, e.length);
  },
  // ISO week of year
  I: function(n, e, t) {
    const r = Fe(n);
    return e === "Io" ? t.ordinalNumber(r, { unit: "week" }) : s(r, e.length);
  },
  // Day of the month
  d: function(n, e, t) {
    return e === "do" ? t.ordinalNumber(n.getDate(), { unit: "date" }) : w.d(n, e);
  },
  // Day of year
  D: function(n, e, t) {
    const r = Ye(n);
    return e === "Do" ? t.ordinalNumber(r, { unit: "dayOfYear" }) : s(r, e.length);
  },
  // Day of week
  E: function(n, e, t) {
    const r = n.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(n, e, t, r) {
    const a = n.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return s(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return t.ordinalNumber(i, { unit: "day" });
      case "eee":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(n, e, t, r) {
    const a = n.getDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return s(i, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return t.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return t.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return t.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(a, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return t.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(n, e, t) {
    const r = n.getDay(), a = r === 0 ? 7 : r;
    switch (e) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return s(a, e.length);
      // 2nd
      case "io":
        return t.ordinalNumber(a, { unit: "day" });
      // Tue
      case "iii":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(n, e, t) {
    const a = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(n, e, t) {
    const r = n.getHours();
    let a;
    switch (r === 12 ? a = P.noon : r === 0 ? a = P.midnight : a = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(n, e, t) {
    const r = n.getHours();
    let a;
    switch (r >= 17 ? a = P.evening : r >= 12 ? a = P.afternoon : r >= 4 ? a = P.morning : a = P.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(n, e, t) {
    if (e === "ho") {
      let r = n.getHours() % 12;
      return r === 0 && (r = 12), t.ordinalNumber(r, { unit: "hour" });
    }
    return w.h(n, e);
  },
  // Hour [0-23]
  H: function(n, e, t) {
    return e === "Ho" ? t.ordinalNumber(n.getHours(), { unit: "hour" }) : w.H(n, e);
  },
  // Hour [0-11]
  K: function(n, e, t) {
    const r = n.getHours() % 12;
    return e === "Ko" ? t.ordinalNumber(r, { unit: "hour" }) : s(r, e.length);
  },
  // Hour [1-24]
  k: function(n, e, t) {
    let r = n.getHours();
    return r === 0 && (r = 24), e === "ko" ? t.ordinalNumber(r, { unit: "hour" }) : s(r, e.length);
  },
  // Minute
  m: function(n, e, t) {
    return e === "mo" ? t.ordinalNumber(n.getMinutes(), { unit: "minute" }) : w.m(n, e);
  },
  // Second
  s: function(n, e, t) {
    return e === "so" ? t.ordinalNumber(n.getSeconds(), { unit: "second" }) : w.s(n, e);
  },
  // Fraction of second
  S: function(n, e) {
    return w.S(n, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(n, e, t) {
    const r = n.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return _(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return b(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return b(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return _(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return b(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return b(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + X(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + b(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + X(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + b(r, ":");
    }
  },
  // Seconds timestamp
  t: function(n, e, t) {
    const r = Math.trunc(+n / 1e3);
    return s(r, e.length);
  },
  // Milliseconds timestamp
  T: function(n, e, t) {
    return s(+n, e.length);
  }
};
function X(n, e = "") {
  const t = n > 0 ? "-" : "+", r = Math.abs(n), a = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? t + String(a) : t + String(a) + e + s(i, 2);
}
function _(n, e) {
  return n % 60 === 0 ? (n > 0 ? "-" : "+") + s(Math.abs(n) / 60, 2) : b(n, e);
}
function b(n, e = "") {
  const t = n > 0 ? "-" : "+", r = Math.abs(n), a = s(Math.trunc(r / 60), 2), i = s(r % 60, 2);
  return t + a + e + i;
}
const L = (n, e) => {
  switch (n) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, A = (n, e) => {
  switch (n) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, qe = (n, e) => {
  const t = n.match(/(P+)(p+)?/) || [], r = t[1], a = t[2];
  if (!a)
    return L(n, e);
  let i;
  switch (r) {
    case "P":
      i = e.dateTime({ width: "short" });
      break;
    case "PP":
      i = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = e.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", L(r, e)).replace("{{time}}", A(a, e));
}, Ne = {
  p: A,
  P: qe
}, He = /^D+$/, Qe = /^Y+$/, Xe = ["D", "DD", "YY", "YYYY"];
function _e(n) {
  return He.test(n);
}
function Le(n) {
  return Qe.test(n);
}
function je(n, e, t) {
  const r = Ge(n, e, t);
  if (console.warn(r), Xe.includes(n)) throw new RangeError(r);
}
function Ge(n, e, t) {
  const r = n[0] === "Y" ? "years" : "days of the month";
  return `Use \`${n.toLowerCase()}\` instead of \`${n}\` (in \`${e}\`) for formatting ${r} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function Be(n) {
  return n instanceof Date || typeof n == "object" && Object.prototype.toString.call(n) === "[object Date]";
}
function Ae(n) {
  return !(!Be(n) && typeof n != "number" || isNaN(+l(n)));
}
const Re = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ve = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ie = /^'([^]*?)'?$/, Je = /''/g, $e = /[a-zA-Z]/;
function Ue(n, e, t) {
  var h, g, M, O, T, F, E, C;
  const r = v(), a = (t == null ? void 0 : t.locale) ?? r.locale ?? ke, i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((g = (h = t == null ? void 0 : t.locale) == null ? void 0 : h.options) == null ? void 0 : g.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((O = (M = r.locale) == null ? void 0 : M.options) == null ? void 0 : O.firstWeekContainsDate) ?? 1, u = (t == null ? void 0 : t.weekStartsOn) ?? ((F = (T = t == null ? void 0 : t.locale) == null ? void 0 : T.options) == null ? void 0 : F.weekStartsOn) ?? r.weekStartsOn ?? ((C = (E = r.locale) == null ? void 0 : E.options) == null ? void 0 : C.weekStartsOn) ?? 0, c = l(n, t == null ? void 0 : t.in);
  if (!Ae(c))
    throw new RangeError("Invalid time value");
  let o = e.match(Ve).map((m) => {
    const f = m[0];
    if (f === "p" || f === "P") {
      const S = Ne[f];
      return S(m, a.formatLong);
    }
    return m;
  }).join("").match(Re).map((m) => {
    if (m === "''")
      return { isToken: !1, value: "'" };
    const f = m[0];
    if (f === "'")
      return { isToken: !1, value: ze(m) };
    if (Q[f])
      return { isToken: !0, value: m };
    if (f.match($e))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + f + "`"
      );
    return { isToken: !1, value: m };
  });
  a.localize.preprocessor && (o = a.localize.preprocessor(c, o));
  const d = {
    firstWeekContainsDate: i,
    weekStartsOn: u,
    locale: a
  };
  return o.map((m) => {
    if (!m.isToken) return m.value;
    const f = m.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && Le(f) || !(t != null && t.useAdditionalDayOfYearTokens) && _e(f)) && je(f, e, String(n));
    const S = Q[f[0]];
    return S(c, f, a.localize, d);
  }).join("");
}
function ze(n) {
  const e = n.match(Ie);
  return e ? e[1].replace(Je, "'") : n;
}
export {
  Ue as f,
  l as t
};
